import React from "react";
import styles from "./financialService.module.css";

const Section = ({
  firstTitle,
  secondTitle,
  firstDescription,
  secondDescription,
  firstImage,
  secondImage,
  firstImageResponsive,
  secondImageResponsive,
  doubleCard,
  orderTextContainer,
}) => {
  return (
    <>
      <div className={styles.section}>
        <div
          className={
            orderTextContainer
              ? styles.orderTextContainer
              : styles.textContainer
          }
        >
          <h2 className={styles.title}>{firstTitle}</h2>
          <p className={styles.description}>{firstDescription}</p>
        </div>
        {firstImage && (
          <img src={firstImage} alt={firstTitle} className={styles.image} />
        )}
        {firstImageResponsive && (
          <img
            src={firstImageResponsive}
            alt={firstTitle}
            className={styles.imageResponsive}
          />
        )}
      </div>
      {doubleCard ? (
        <div className={styles.section}>
          {secondImage && (
            <img
              src={secondImage}
              alt={secondTitle}
              className={
                orderTextContainer
                  ? styles.orderSecondTextContainer
                  : styles.image
              }
            />
          )}
          {secondImageResponsive && (
            <img
              src={secondImageResponsive}
              alt={secondTitle}
              className={styles.imageResponsive}
            />
          )}
          <div className={styles.textContainer}>
            <h2 className={styles.title}>{secondTitle}</h2>
            <p className={styles.description}>{secondDescription}</p>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Section;
